import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import "primeicons/primeicons.css";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const SequenceManager = ({ initialItems = [], onSave }) => {

  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  const onDragEnd = (result) => {

    if (!result.destination) return;

    const reorderedItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );

    const updatedItems = reorderedItems.map((item, index) => ({
      ...item,
      orderIndex: index
    }));

    setItems(updatedItems);
  };

  const handleSave = () => {
    if (onSave) {
      onSave(items);
    }
  };

  const filteredItems = items.filter((item) =>
    item.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="sequence-manager-page">

      <div className="heading-area">
        <div className="title">
          <i className="pi pi-sort-alt"></i>
          <h2>Manage Access Sequence</h2>
        </div>

        <div className="actions">

          <div className="search">
            <InputText
              placeholder="Search Menu"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <i className="pi pi-search"></i>
          </div>

          <Button
            icon="pi pi-save"
            label="Save"
            className="save-btn"
            onClick={handleSave}
          />

        </div>
      </div>

      <hr />

      <div className="sequence-container">

        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="sequence">

            {(provided) => (

              <div
                className="drag-wrapper"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >

                {filteredItems.map((item, index) => (

                  <Draggable
                    key={item._id}
                    draggableId={item._id}
                    index={index}
                  >

                    {(provided, snapshot) => (

                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={`drag-item ${snapshot.isDragging ? "dragging" : ""}`}
                      >

                        <div className="left">
                          <i className="pi pi-bars"></i>
                          <span>{item.name}</span>
                        </div>

                        <div className="right">
                          #{index + 1}
                        </div>

                      </div>

                    )}

                  </Draggable>

                ))}

                {provided.placeholder}

              </div>

            )}

          </Droppable>
        </DragDropContext>

      </div>

    </div>
  );
};

export default SequenceManager;